import NotificationAPIClient from 'notificationapi-js-client-sdk';
import React, { useEffect } from 'react';
import styled from 'styled-components';

const NotificationapiTemplatePreviewDiv = styled.div`
  & .notificationapi-container {
    width: 100%;
  }

  & .notificationapi-popup {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  & * {
    pointer-events: ${(props: { disableClick?: boolean }) =>
      props.disableClick ? 'none' : 'auto'};
  }

  & .notificationapi-preferences-button {
    display: none !important;
  }
  & .notificationapi-nomore {
    display: none !important;
  }
  & .notificationapi-header {
    display: none !important;
  }
  & .notificationapi-footer {
    display: none !important;
  }
`;

export const InAppPreview = (props: {
  title?: string;
  imageURL?: string;
  redirectURL?: string;
  time?: string;
  uniqueId: string;
  disableClick?: boolean;
}): JSX.Element => {
  useEffect(() => {
    const notificationapi = new NotificationAPIClient({
      clientId: 'a',
      userId: 'a',
      websocket: false
    });

    notificationapi.showInApp({
      root: `notificationapi-template-preview-div-${props.uniqueId}`,
      inline: true
    });

    notificationapi.websocketHandlers.notifications({
      route: 'inapp_web/notifications',
      payload: {
        notifications: [
          {
            title: props.title ?? '',
            redirectURL: props.redirectURL,
            imageURL: props.imageURL,
            date: new Date(props.time ?? '').toISOString(),
            id: new Date(props.time ?? '').toISOString(),
            seen: true
          }
        ]
      }
    });
  }, [
    props.uniqueId,
    props.title,
    props.imageURL,
    props.redirectURL,
    props.time
  ]);

  return (
    <NotificationapiTemplatePreviewDiv
      id={`notificationapi-template-preview-div-${props.uniqueId}`}
      disableClick={
        props.disableClick !== undefined ? props.disableClick : true
      }
    ></NotificationapiTemplatePreviewDiv>
  );
};
